import type { EnrollmentFilter, EnrollmentGroup, CourseGroup } from './vuex';

export default {
  enrollmentGroups: [] as EnrollmentGroup[],
  courseGroup: null as CourseGroup | null,
  filter: 'showAll' as EnrollmentFilter,
  searchString: '',
};
